/**
 * FiscalPeriodWarning
 *
 * Inline banner shown on transaction forms when the selected date falls in a
 * closed/locked fiscal period (driven by useFiscalPeriodCheck). Renders nothing
 * when there is no warning, so it can be dropped into any form unconditionally.
 */

interface FiscalPeriodWarningProps {
  message: string | null | undefined
}

export function FiscalPeriodWarning({ message }: FiscalPeriodWarningProps): JSX.Element | null {
  if (!message) { return null }
  return (
    <div className="card el-p-md flex items-start gap-2 border border-yellow-400 dark:border-yellow-600 bg-yellow-50 dark:bg-yellow-900/20">
      <span className="text-yellow-600 dark:text-yellow-400 text-base leading-none mt-0.5">&#9888;</span>
      <div>
        <span className="text-sm font-semibold text-yellow-800 dark:text-yellow-200">Fiscal period warning</span>
        <p className="text-xs text-yellow-700 dark:text-yellow-300 mt-0.5">{message}</p>
      </div>
    </div>
  )
}
